'use strict';

import versioner from '../versioner';
import process from './process';

for (const version of [
	'wichita_pump_stations_after_hours',
	'wichita_pump_stations_v1_mon_daytime',
	'wichita_pump_stations_v1_mon_pm',
	'wichita_pump_stations_v1_tue_daytime',
	'wichita_pump_stations_v1_tue_pm',
	'wichita_pump_stations_v1_wed_daytime',
	'wichita_pump_stations_v1_wed_pm',
	'wichita_pump_stations_v1_thu_daytime',
	'wichita_pump_stations_v1_thu_pm',
	'wichita_pump_stations_v1_fri_daytime',
	'wichita_pump_stations_v1_weekend',
]) {
	versioner[version] = {
		process: process,
	}
}

const MODULE_NAME = 'daupler.incidents.versions.wichita_pump_stations';

export default MODULE_NAME;
